module.exports = __webpack_public_path__ + "img/product-category-eternityrings.4eb7bee.jpg";